<template>
  <v-container fluid>
    <v-row
      no-gutters
      align="center"
      justify="center"
    >
      <v-card
        width="100%"
        flat
        class="pa-1"
        @click="toAccountPage('basic')"
      >
        <v-row no-gutters>
          <v-avatar
            tile
            size="37"
            color="blue"
          >
            <img
              v-if="user.avatar"
              :src="user.avatar"
            >
            <v-icon
              v-else
              dark
            >
              fa fa-user
            </v-icon>
          </v-avatar>
          <div class="pl-4">
            <div class="font-weight-bold">
              {{ user.name }}
            </div>
            <span class="caption">{{ user.email }}</span>
          </div>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { toRhitics } from '@rhitics/utils/links'

export default {
  name: 'UserMenu',

  computed: {
    user() {
      return this.$auth.user
    }
  },

  methods: {
    toAccountPage(subPage) {
      toRhitics('account', subPage)
    }
  }
}
</script>
